import React, {Component} from 'react';
import Picker from 'react-mobile-picker';
import disableScroll from 'disable-scroll';
import './index.css'
import {Button} from "antd";

function generateNumberArray(begin, end) {
    let array = [];
    for (let i = begin; i <= end; i++) {
        array.push((i < 10 ? '0' : '') + i);
    }
    return array;
}

export default class CircularDatePicker extends Component {
    constructor(props) {
        super(props);
        const value = props.value==undefined? '1380-01-01' : props.value;
        const vals = value.split("-");
        this.state = {
            isPickerShow: false,
            isBirthDayShow: props.isBirthDayShow || false,
            valueGroups: {
                year: vals[0],
                month: this.twoDigit(vals[1]),
                day: this.twoDigit(vals[2]),
            },
            optionGroups: {
                day: generateNumberArray(1, 31),
                month: generateNumberArray(1, 12),
                year: generateNumberArray(1300, 1500),
            }
        };
    }
    twoDigit = (val) => {
        if(val.length==1){
            return "0" + val;
        }
        return val;
    }
    handleChange = (name, value) => {
        this.setState(({valueGroups, optionGroups, isBirthDayShow}) => {
            const nextState = {
                valueGroups: {
                    ...valueGroups,
                    [name]: value
                },
                isBirthDayShow: true
            };
            if (name === 'year' && valueGroups.month === '12') {
                const yearValue = parseInt(value);
                if (yearValue % 4 === 3) {
                    nextState.optionGroups = {
                        ...optionGroups,
                        day: generateNumberArray(1, 30)
                    };
                } else {
                    nextState.optionGroups = {
                        ...optionGroups,
                        day: generateNumberArray(1, 29)
                    };
                }
            } else if (name === 'month') {
                if (value === '12') {
                    nextState.optionGroups = {
                        ...optionGroups,
                        day: generateNumberArray(1, 29)
                    };
                } else if (['07', '08', '09', '10', '11'].indexOf(value) > -1 &&
                    ['07', '08', '09', '10', '11', '12'].indexOf(valueGroups.month) < 0) {
                    nextState.optionGroups = {
                        ...optionGroups,
                        day: generateNumberArray(1, 30)
                    };
                } else if (['07', '08', '09', '10', '11', '12'].indexOf(value) < 0 &&
                    ['07', '08', '09', '10', '11', '12'].indexOf(valueGroups.month) > -1) {
                    nextState.optionGroups = {
                        ...optionGroups,
                        day: generateNumberArray(1, 31)
                    };
                }
            }
            return nextState;
        });
        const valueGroups= {
        ...this.state.valueGroups,
                [name]: value
        }
        const val = valueGroups.year + '/' + valueGroups.month + '/' + valueGroups.day;
        const { onChange } = this.props;

        if (onChange) {
            // This will provide the form with changes
            onChange({ ...{ value: val } });
        }

    };
    togglePicker = () => {
        this.setState(({isPickerShow}) => ({
            isPickerShow: !isPickerShow

        }));

    };

    render() {
        const {isPickerShow, optionGroups, valueGroups} = this.state;
        const maskStyle = {
            display: isPickerShow ? 'block' : 'none'
        };
        var root = document.getElementsByTagName('html')[0];
        const pickerModalClass = `picker-modal${isPickerShow ? ' picker-modal-toggle' : ''}`;
        if (isPickerShow) {
            document.body.classList.add('picker-modal-open')
            root.classList.add('picker-modal-open');
            disableScroll.on();
        } else {
            document.body.classList.remove('picker-modal-open')
            root.classList.remove('picker-modal-open');
            disableScroll.off();
        }

        return (
            <div className="example-container">
                <div className="weui_cells">
                    <div className="weui_cell weui_cell_select weui_select_after">
                        <div className="weui_cell_bd weui_cell_primary">
                            <input
                                type="text"
                                className="datepicker-input"
                                value={this.state.isBirthDayShow ? valueGroups.year + '-' + valueGroups.month + '-' + valueGroups.day : ''}
                                readOnly
                                onClick={this.togglePicker}/>
                        </div>
                    </div>
                </div>
                <div className="picker-modal-container">
                    <div className="picker-modal-mask" style={maskStyle} onClick={this.togglePicker}></div>
                    <div className={pickerModalClass}>
                        <header>
                            <div className="title">تاریخ تولد خود را انتخاب کنید</div>
                        </header>
                        <Picker
                            optionGroups={optionGroups}
                            valueGroups={valueGroups}
                            onChange={this.handleChange}/>
                        <div className='px-40'>
                            <Button type="primary" block onClick={this.togglePicker}>ذخیره</Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}